import {Doc} from "./Doc";
import {Payment} from "./Payment";
import {BankDTOResponse} from "../BankDTOResponse";
import {GrouperDTOResponse} from "../GrouperDTOResponse";
import {Account} from "./Account";


export class Bookkeeping {
  id: number;
  companyId: number;
  amountPaid: number;
  amountPaidCalc: number;
  amountPaidFormated: string;
  balance: number;
  createdBy: string;
  createdAt: any;
  planPaymentId: number;
  historic: string;
  account: Account;
  grouper: GrouperDTOResponse[];
  paymentDate: any;
  paymentDateFormated: string;
  postingReleaseType: string;
  bankAccount: BankDTOResponse;
  doc: Doc;
  payment: Payment;
  digital: boolean;
  incoming: string;
  outlay: string;
  isImported: any;
  postingType: string;
  balanceFormated: string;
  month: string;
  incomingNumber: number;
  outlayNumber: number;
  ofxId: number;
  importType: string;
  installmentId: number;
  installmentType: string;
}
